<div class="container">
  <div class="row">
    <div class="col-md-6" style="color:black; padding-top:1%; font-size:1.4em; font-weight:bold ">
      In re Generic Pharmaceuticals Antitrust Litigation
    </div>
    <div class="col-md-6">
      <div class="float-right phoneNumber" style="font-size: 1.4em; padding-top: 3%; font-weight: bold">1-877-316-0171</div>
    </div>
    <div class="col-md-12" style="padding-left:0px; padding-right:0px">

    </div>
  </div>
</div>
<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #000042 ">
    <div class="container">
      <button class="navbar-toggler" type="button" style="background-color:white" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/landing']" style="color:white; font-weight:bold">All Classes Page</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/sun-taro-classes-homepage']" style="color:white; font-weight:bold">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color:white; font-weight:bold">File a Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/sun-taro-classes-notice']" style="color:white; font-weight:bold">Notice/FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/sun-taro-classes-courtdocuments']" style="color:white; font-weight:bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/sun-taro-classes-espanol']" style="color:white; font-weight:bold">Español</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/sun-taro-classes-contact']" style="color:white; font-weight:bold">Contact Information</a>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</header>
<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
      <p class="text-center" style="font-size:1.0em; color:white">
        This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
        No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
      </p>
    </div>
  </div>
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <h2 class="#353535" id="FontTwo"><b>Notice / FAQs</b></h2>
      For answers to frequently asked questions, please review the Notice using the links below.<br />

      <ul>
        <li>
          <a href="./assets/Docs/Relating to the Sun Taro Settlement/Long Form Notice - SunTaro 2025-09-30.pdf"
             target="_blank">
            Notice
          </a>
        </li>
        <li>
          <a href="./assets/Docs/Relating to the Sun Taro Settlement/Summary Notice re SunTaro 2025-09-30.pdf"
             target="_blank">
            Summary Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/Docs/2026/Drug List for Claim Form (2026-07-30).pdf"
             target="_blank">
            Named Generic Drugs
          </a>
        </li>
      </ul>
    </div>
  </div>
  <br />
  <br />
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#C40A0A; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
  <br />
</div>

